import { ButtonPrimary } from "components/Atoms/Button";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import { DeleteDialog } from "../../components";
import { OrderableList } from "../../components/Tables";
import { Panel } from "../../components/panels";
import ChecklistItem from "./ChecklistItem";
import { NewChecklistItemModal } from "./NewChecklistItemModal";

const ChecklistPresetItemList = () => {
  const viewModel = useLoaderData<server.viewmodel.ChecklistPresetItemListFrontModel>();

  const [initialLoading, setInitialLoading] = React.useState(true);
  const [checklistItems, setChecklistItems] = React.useState<server.dto.ChecklistPresetItem[]>([]);
  const [creatingItem, setCreatingItem] = React.useState(false);
  const [deletingItem, setDeletingItem] = React.useState<server.dto.ChecklistPresetItem>();

  React.useEffect(() => {
    window.CoreApi.ChecklistPreset.ListChecklistPresetItem(viewModel.checklistType)
      .then(res => {
        setChecklistItems(res.data);
        setInitialLoading(false);
      });
  }, []);

  const onCreated = async () => {
    await refreshList();
  };

  const onEdit = async (newQuestion: string, checklistPresetItemId: number) => {
    await window.CoreApi.ChecklistPreset.UpdateChecklistPresetItem({
      checklistPresetItemId,
      question: newQuestion
    });

    await refreshList();
  };

  const onDelete = async () => {
    await window.CoreApi.ChecklistPreset.DeleteChecklistPresetItem(deletingItem.checklistPresetItemId);
    await refreshList();
    setDeletingItem(undefined);
  };

  const onMove = async (newOrder: server.dto.ChecklistPresetItem[]) => {
    setChecklistItems(newOrder);
    await window.CoreApi.ChecklistPreset.UpdateChecklistPresetItemOrder({
      checklistType: viewModel.checklistType,
      checklistPresetItemIds: newOrder.map(i => i.checklistPresetItemId)
    });
    return refreshList();
  };

  const refreshList = async () => {
    const res = await window.CoreApi.ChecklistPreset.ListChecklistPresetItem(viewModel.checklistType);
    setChecklistItems(res.data);
  };

  const newChecklistItem = () => {
    setCreatingItem(true);
  };

  return <>
    <TwoColumnLayout>
      <TwoColumnLayout.LeftColumn>
        <Panel
          panelClassName="s1_listview-panel"
          title={RESX.Checklist.ChecklistPreset}
          articleId={serverReference.supportArticleIds.whatIsAChecklistPreset}
          subTitle={viewModel.subTitle}
          headerSize="h1"
          isLoading={initialLoading}
          button={<ButtonPrimary label={RESX.Buttons.btnNew} onClick={newChecklistItem} />}
        >
          {!initialLoading && !creatingItem && checklistItems.length === 0 && <NoDataAvailableDiv />}
          <OrderableList
            listId="checklistItems"
            items={checklistItems}
            getKey={f => `${f.checklistPresetItemId}`}
            onOrderChanged={onMove}
            render={(item) => <ChecklistItem
              key={item.checklistPresetItemId}
              item={item}
              onSave={onEdit}
            />}
            onDelete={(item) => { setDeletingItem(item); }}
          />
          <DeleteDialog
            isOpen={deletingItem != null}
            onDelete={onDelete}
            handleClose={() => { setDeletingItem(undefined); }}
            message={RESX.GeneralWarnings.DeleteSure}></DeleteDialog>
        </Panel>
      </TwoColumnLayout.LeftColumn>
      <RightSideNavigation
        title={site.navigation.rightSideNavigation.title}
        menuItems={site.navigation.rightSideNavigation.items}
        currentPage={site.currentPage}
      />
    </TwoColumnLayout>
    <NewChecklistItemModal
      checklistType={viewModel.checklistType}
      isOpen={creatingItem}
      onClose={() => setCreatingItem(false)}
      onCreated={onCreated}
    />
  </>
};

export default ChecklistPresetItemList;